import { Component } from '@angular/core';
import { CardPriceComponent } from '../../components/card-price/card-price.component';
@Component({
  selector: 'app-plans-service',
  standalone: true,
  imports: [CardPriceComponent],
  templateUrl: './plans-service.component.html',
  styleUrl: './plans-service.component.scss'
})
export class PlansServiceComponent {

}
